export default __webpack_public_path__ + "static/cement_sign-6b43258dd860231da1f88d0c5d7a990f.jpeg";